import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { createUser, fetchUsersList } from '../actions';
import { Checkbox } from '../../../components/Checkbox';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const STATE = {
  isOpen: false,
  user: {
    name: '',
    surname: '',
    password: '',
    email_address: '',
  },
  fieldErrors: null,
  error: '',
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const TextError = styled.div`
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: red;
`;

const Required = styled.div`
  font-size: 14px;
  color: red;
`;

/* eslint-disable react/prefer-stateless-function */
class UserModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
    this.props.toggle();
  }

  onUserInputChange(evt) {
    const { name, value } = evt.target;
    let emailError = '';
    if (name === 'email_address') {
      if (value && !emailRegex.test(value)) {
        emailError = 'Incorrect email';
      }
    }
    this.setState((prev, props) => {
      return { ...prev, user: { ...prev.user, [name]: value }, emailError: emailError };
    });
    return this;
  }

  toggleWeblogin(evt) {
    this.setState((prev, props) => {
      return { ...prev, user: {
        ...prev.user,
          weblogin: !prev.user?.weblogin,
          can_login_to_vindat: !prev.user?.weblogin ? false : prev.user?.can_login_to_vindat,
      } };
    });
  }

  toggleCanLoginToVindat(evt) {
    this.setState((prev, props) => {
      return { ...prev, user: {
        ...prev.user,
          can_login_to_vindat: !prev.user?.can_login_to_vindat,
          weblogin: !prev.user?.can_login_to_vindat ? false : prev.user?.weblogin,
      } };
    });
  }

  createUserToCompany() {
    const { name, surname, email_address, password, weblogin, can_login_to_vindat } = this.state.user;
    if (!email_address) {
      this.setState({
        error: 'Please fill in the email field',
      });
      return;
    }

    const userDto = {
      email_address,
      password,
      weblogin: !!weblogin,
      can_login_to_vindat: !!can_login_to_vindat,
      properties: [
        { name: 'name', value: name },
        { name: 'surname', value: surname },
      ],
    };

    this.props.createUser(userDto, result => {
      if (result) {
        const isEmailValue = result.message;

        if (!result.result) {
          this.setState({
            error: isEmailValue,
          });
        }
        this.props.addToCompany && this.props.addToCompany(result?.id);
        !this.props.addToCompany && this.props.fetchUsersList();

        if (result.id) {
          this.reset();
        }
      }
    });
  }

  handleSave = () => {
    this.createUserToCompany();
  };

  render() {
    const { name, surname, password, email_address } = this.state.user;
    const { emailError, error } = this.state;
    const isDisable = emailError || !email_address || !name || !surname;

    return (
      <>
        <Modal key={'new_user'} onClose={this.reset.bind(this)} title={this.lbl('company.details.create_user')}>
          {error && <TextError>{error}</TextError>}
          <VBox left>
            <FormField label={this.lbl('user.details.name')} full >
              <Input name="name" value={name ?? ''} placeholder={'name'} onChange={this.onUserInputChange.bind(this)} full />
            </FormField>
            <FormField label={this.lbl('user.details.surname')} full >
              <Input
                name="surname"
                value={surname ?? ''}
                placeholder={'surname'}
                onChange={this.onUserInputChange.bind(this)}
                full
              />
            </FormField>
            <FormField label={this.lbl('user.details.password')} full>
              <Input
                type="password"
                name="password"
                value={password ?? ''}
                placeholder={'password'}
                onChange={this.onUserInputChange.bind(this)}
                full
              />
            </FormField>
            <FormField label={this.lbl('user.details.email_address')} full >
              <Input
                name="email_address"
                value={email_address ?? ''}
                placeholder={'email_address'}
                full
                onChange={this.onUserInputChange.bind(this)}
              />
              {emailError && <Required>{emailError}</Required>}
            </FormField>
            <FormField full>
              {env.clientId === AppClientId.INDEWAL  && (
                <Checkbox checked={this.state.user?.weblogin == '1'} onChange={this.toggleWeblogin.bind(this)}>
                  <strong>{this.lbl('user.details.weblogin')}</strong>
                </Checkbox>
              )}
              <Checkbox checked={this.state.user?.can_login_to_vindat == '1'} onChange={this.toggleCanLoginToVindat.bind(this)}>
                <strong>{this.lbl('user.details.can_login_to_vindat')}</strong>
              </Checkbox>
            </FormField>
          </VBox>

          <ModalControls>
            <Button primary onClick={this.handleSave} disabled={isDisable}>
              Save
            </Button>
            <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
          </ModalControls>
        </Modal>
      </>
    );
  }
}

UserModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  toggle: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {};
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    createUser(user, callback) {
      dispatch(createUser(user, callback));
    },
    fetchUsersList() {
      dispatch(fetchUsersList());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserModal = compose(withConnect, withRouter, injectIntl)(UserModalComp);
